(function () {

    "use strict";

    console.log("🎨 TrustShop Renderer Started");

    function waitForTrustShop() {

        const timer = setInterval(function () {

            const reviewList = document.querySelector(
                ".trustshop-review--list"
            );

            const template = document.querySelector(
                ".trustshop-review-item-type--grid"
            );

            if (!reviewList || !template) {

                return;

            }

            if (!window.MERGED_REVIEWS) {

                return;

            }

            clearInterval(timer);

            renderReviews(
                reviewList,
                template
            );

        }, 300);

    }

    function renderReviews(
        reviewList,
        template
    ) {

        console.log(
            "Rendering",
            window.MERGED_REVIEWS.length,
            "reviews"
        );

        /*
        Remove previously injected reviews
        */

        reviewList
            .querySelectorAll(".acr-generated-review")
            .forEach(function (el) {

                el.remove();

            });

        /*
        Skip TrustShop reviews.
        Only append generated reviews.
        */

        const generated =
            window.GENERATED_REVIEWS || [];

        generated.forEach(function (review) {

            const card =
                template.cloneNode(true);

            populateCard(
                card,
                review
            );

            card.classList.add(
                "acr-generated-review"
            );

            reviewList.appendChild(card);

        });

        console.log(
            "Generated Reviews Added:",
            generated.length
        );

    }

    function populateCard(
        card,
        review
    ) {

        /*
        Name
        */

        const name =
            card.querySelector(
                ".trustshop-review--author_name p"
            );

        if (name) {

            name.textContent =
                review.name;

        }

        /*
        Avatar
        */

        const avatar =
            card.querySelector(
                ".trustshop-author-avt--text"
            );

        if (avatar) {

            avatar.textContent =
                review.name
                    .charAt(0)
                    .toUpperCase();

        }

        /*
        Review
        */

        const content =
            card.querySelector(
                ".trustshop-review--content span"
            );

        if (content) {

            content.textContent =
                review.review;

        }

        card.setAttribute(
            "data-origin-review--content",
            review.review
        );

        /*
        Date
        */

        const time =
            card.querySelector(
                ".trustshop-post-time time"
            );

        if (time) {

            time.textContent =
                review.date;

            time.setAttribute(
                "datetime",
                review.date
            );

        }

        
/*
Stars
*/

const starsContainer = card.querySelector(
    ".trustshop-review--rating .trustshop-stars"
);

if (starsContainer) {

    starsContainer.innerHTML = "";

    for (let i = 1; i <= 5; i++) {

        starsContainer.innerHTML += `
            <span class="trustshop-rating-star--container" style="display:inline-flex;">
                <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7.16604 12.1708C7.48383 11.979 7.88171 11.979 8.19951 12.1708L10.858 13.7754C11.6153 14.2325 12.5495 13.5535 12.3486 12.692L11.6431 9.6678C11.5587 9.30631 11.6816 8.92784 11.9621 8.68479L14.3124 6.64873C14.981 6.06952 14.6236 4.97126 13.7422 4.89648L10.65 4.63414C10.2804 4.60278 9.95851 4.36944 9.81377 4.02794L8.60349 1.17237C8.2589 0.359342 7.10664 0.359342 6.76205 1.17237L5.55177 4.02794C5.40703 4.36944 5.08517 4.60278 4.71559 4.63414L1.62335 4.89648C0.741922 4.97126 0.384515 6.06952 1.05311 6.64873L3.40341 8.68479C3.68397 8.92784 3.80682 9.30631 3.72249 9.6678L3.01697 12.692C2.81601 13.5535 3.75024 14.2325 4.50756 13.7754L7.16604 12.1708Z"
                        fill="${i <= review.rating ? "#FFB400" : "#E0E0E0"}">
                    </path>
                </svg>
            </span>
        `;

    }

}

    }

    waitForTrustShop();

})();